const menuButton = document.getElementById('menu-button');
const menuItems = document.getElementsByClassName('menu-items')[0];
const floatingMenu = document.getElementById('floating-menu');
const scrollUpButton = document.getElementById('scroll-up-button');
const menuItemList = Array.from(document.querySelectorAll('.menu-item'));

const animateMenuItem = (menuItem, delay) => {
  setTimeout(() => {
    menuItem.style.opacity = 1;
  }, delay);
};

const toggleMenu = () => {
  menuItems.classList.toggle('collapsed');
  floatingMenu.classList.toggle('collapsed');
  animateMenuItems();
  updateMenuButton();
};

const updateMenuButton = () => {
  const menuButtonIcon = menuButton.firstElementChild;
  if (floatingMenu.classList.contains('collapsed')) {
    menuButtonIcon.className = 'fa fa-comments';
    menuButton.style.backgroundColor = '#fb9aaa'; // Default color
  } else {
    menuButtonIcon.className = 'fa fa-times';
    menuButton.style.backgroundColor = '#fa5372'; // Slightly darker color
  }
};

const animateMenuItems = () => {
  if (floatingMenu.classList.contains('collapsed')) {
    menuItemList.forEach((item, index) => {
      setTimeout(() => {
        item.style.opacity = '0';
        item.style.transform = 'rotate(360deg)';
      }, index * 100);
    });
  } else {
    menuItemList.forEach((item, index) => {
      setTimeout(() => {
        item.style.opacity = '1';
        item.style.transform = 'rotate(0)';
      }, index * 70);
    });
  }
};

menuButton.addEventListener('click', toggleMenu);

document.addEventListener('click', (event) => {
  if (!floatingMenu.contains(event.target)) {
    menuItems.classList.add('collapsed');
    floatingMenu.classList.add('collapsed');
    animateMenuItems();
    updateMenuButton();
  }
});

scrollUpButton.addEventListener('click', () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

document.addEventListener('scroll', () => {
  const scrollTop = window.scrollY;
  
  // Show or hide the scroll-up button
  if (scrollTop > 100) { // Adjust this value as needed
    scrollUpButton.classList.add('visible');
  } else {
    scrollUpButton.classList.remove('visible');
  }
});

// Initialize the menu items animation on page load
menuItemList.forEach((menuItem, index) => {
  menuItem.style.opacity = '0';
  menuItem.style.transform = 'rotate(360deg)';
  animateMenuItem(menuItem, index * 100);
});
